import { useFormik } from "formik";
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  initial_values,
  validationSchema,
} from "../../../FormValidations/AccountManagementSchema";
import ChangePassword from "../../../sections/CustomerDashboard/Settings/ChangePassword";
import { AdminPageTitle } from "../../../sections/AdminDashboard/shared/adminUx";
import DashboardMainContainer from "../../../components/common/Containers/DashboardMainContainer";
import { CUSTOMER_CENTERED_PAGE_TITLE_CLASS } from "../../../sections/CustomerDashboard/shared/customerLayoutSpec";

const CustomerResetPassword = () => {
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: initial_values,
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => {},
  });
  return (
    <DashboardMainContainer className="lg:px-5 lg:pb-10">
      <AdminPageTitle className={`text-offblack ${CUSTOMER_CENTERED_PAGE_TITLE_CLASS}`}>
        Reset password
      </AdminPageTitle>
      <div className="flex justify-center min-h-screen">
        <form onSubmit={formik.handleSubmit} className="w-full">
          <ChangePassword />
        </form>
      </div>
    </DashboardMainContainer>
  );
};

export default CustomerResetPassword;
